import { useQuery } from '@tanstack/react-query';
import { useToast } from 'hooks/ui';
import { getUserHomePageSettings } from 'api/appSettings.service';
import { HomePageWidgets_queryKey } from './constants';
import { useEffect } from 'react';

export const useGetHomePageWidgetsQuery = () => {
  const toast = useToast();

  const { data, isLoading, error } = useQuery({
    queryKey: [HomePageWidgets_queryKey],
    queryFn: () => getUserHomePageSettings(),
    // We don't expect the data to be frequently updated by external factors
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (error) toast.error(error.message);
  }, [error, toast]);

  return {
    personalizedConfig: data?.layout,
    isCustomized: data?.isCustomized ?? false,
    isLoading,
    widgets: data?.widgets,
  };
};
